import { alpha, styled, TextField } from '@mui/material';
import { spaceCadet } from '../utils/colors';

const CogNeedTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
      '&::placeholder': {
        color: spaceCadet[400],
      },
    },
  },
  backgroundColor: alpha(spaceCadet[100], 0.5),
  borderRadius: 4,
  color: spaceCadet[800],
  '& .MuiInputAdornment-root .MuiSvgIcon-root': {
    opacity: 0.5,
    color: spaceCadet[400],
  },
  '&:hover': {
    backgroundColor: spaceCadet[100],
  },
});

export default CogNeedTextField;
